import { render } from "./TableSimple.vue?vue&type=template&id=65d88a9a"
import script from "./TableSimple.vue?vue&type=script&lang=js"
export * from "./TableSimple.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__